module.exports = __webpack_public_path__ + "scroll-down.png?b62e03a4b00b40d6a9fece6cd60552ba";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scroll-down.png
// module id = 88
// module chunks = 0